import { apiRequest } from "./client";

/**
 * NestJS tasks contract (Part 72 §72.3):
 * GET /api/tasks?status=&ownerId=&q=&page=&size= → { items, total, page, size }.
 */
const LIST_SIZE = 200;

export const tasksApi = {
  getAll: async (q, extra = {}) => {
    const params = new URLSearchParams({ page: "1", size: String(LIST_SIZE) });
    if (q?.trim()) params.set("q", q.trim());
    if (extra.status && extra.status !== "all") params.set("status", extra.status);
    if (extra.linkedType && extra.linkedId) {
      params.set("linkedType", extra.linkedType);
      params.set("linkedId", extra.linkedId);
    }
    const data = await apiRequest(`/api/tasks?${params}`);
    return (data?.items || []).map((task) => ({
      ...task,
      createdAtUtc: task.createdAtUtc ?? task.createdAt ?? null,
    }));
  },
  create: (payload) => apiRequest("/api/tasks", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => apiRequest(`/api/tasks/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  remove: (id) => apiRequest(`/api/tasks/${id}`, { method: "DELETE" }),
};
